import { memoize } from 'lodash'
import { RoleEnum } from '~/bff/graphql/generated/graphql'

/**
 * Determines if the user has any of the required roles.
 *
 * @param allowedRoles - A set of roles required to access a feature.
 * @param userRoles - A set of roles the user currently has.
 * @returns {boolean} - True if the user has any of the required roles, otherwise false.
 */
export const hasRole = memoize((allowedRoles: RoleEnum[] = [], userRoles: RoleEnum[] = []) =>
  allowedRoles.some((role) => userRoles.includes(role)),
)
